import { useEffect } from 'react'
import 'intersection-observer' // Polyfill for IOS Safari

// Detects if an element is intersecting the viewport (is scrolled into view)
export const useIntersectionObserver = (
  ref,
  onIntersect,
  options = {},
  disconnectOnIntersect = false,
) => {
  useEffect(() => {
    if (!ref.current) {
      return
    }

    const observer = new window.IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          onIntersect(entry)
          if (disconnectOnIntersect) {
            observer.disconnect()
          }
        }
      })
    }, options)
    observer.observe(ref.current)

    return () => {
      observer.disconnect()
    }
  }, [ref, disconnectOnIntersect, onIntersect, options])
}
